// extracted by mini-css-extract-plugin
export default {"container":"label_container__zTVHF CommonStyles_inputLabel__HxTfx","warning":"label_warning__vZl6C CommonStyles_iconInLabel__TErh+","label":"label_label__CRY26"};